module.exports = __webpack_public_path__ + "img/banner3.edcb1b34.png";